import React from 'react';

import { PageHeaderLayout } from '@/shared/components';

const AgreePage: React.FC = () => {
  return <PageHeaderLayout headerName={'Agree Page'} />
}

export default AgreePage;